import { render, staticRenderFns } from "./OrderTypeMaintain.vue?vue&type=template&id=475b69fa"
import script from "./OrderTypeMaintain.vue?vue&type=script&lang=js"
export * from "./OrderTypeMaintain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports